<template>
  <div class="header-bar">
    <v-menu offset-y left nudge-bottom="6" content-class="lang-menu">
      <template v-slot:activator="{ on, attrs }">
        <button v-bind="attrs" v-on="on" type="button" class="lang-pill">
          <v-avatar size="20">
            <v-img :src="model ? model.flagSrc : require('@/assets/iran.png')" alt="Lang" />
          </v-avatar>
          <span>{{ model ? model.title : $t("select language") }}</span>
          <v-icon small>mdi-chevron-down</v-icon>
        </button>
      </template>

      <v-list dense class="py-1">
        <v-list-item
          v-for="lang in languages"
          :key="lang.id"
          @click="changeLanguage(lang.lang)"
        >
          <v-list-item-avatar size="22">
            <v-img :src="lang.flagSrc" />
          </v-list-item-avatar>
          <v-list-item-title>{{ lang.title }}</v-list-item-title>
          <v-list-item-action v-if="model && model.lang === lang.lang" class="my-0">
            <v-icon small color="primary">mdi-check</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "AppHeader",
  data: () => ({
    languages: [
      {
        id: 1,
        title: "فارسی",
        lang: "fa",
        rtl: true,
        flagSrc: require("@/assets/iran.png"),
      },
      {
        id: 2,
        title: "English",
        lang: "en",
        rtl: false,
        flagSrc: require("@/assets/england.png"),
      },
    ],
    model: null,
  }),
  mounted() {
    const langFromStore = this.$store.state.lang;
    const langStorage = JSON.parse(localStorage.getItem("lang"));

    const currentLang =
      this.languages.find(x => x.lang === (langStorage?.lang || langFromStore)) ||
      this.languages[0];

    this.model = currentLang;
    this.$root.$i18n.locale = currentLang.lang;
    this.$vuetify.rtl = currentLang.rtl;
  },
  methods: {
    changeLanguage(langCode) {
      const langObj = this.languages.find(l => l.lang === langCode);
      if (!langObj) return;

      this.model = langObj;

      const tokenStorage = JSON.parse(localStorage.getItem("token"));
      if (tokenStorage) {
        tokenStorage.init.lang.value = langObj.lang;
        localStorage.setItem("token", JSON.stringify(tokenStorage));
      } else {
        localStorage.setItem("lang", JSON.stringify(langObj));
      }

      this.$root.$i18n.locale = langObj.lang;
      this.$vuetify.rtl = langObj.rtl;
      this.$emit("input", langObj);
    },
  },
};
</script>

<style scoped>
.header-bar {
  display: flex;
  justify-content: flex-end;
}
.lang-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 12px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #e2e8f0;
  color: #0f172a;
  font-size: 13px;
  font-weight: 500;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
  transition: border-color .2s, box-shadow .2s;
  cursor: pointer;
}
.lang-pill:hover {
  border-color: #0066ff;
  box-shadow: 0 0 0 4px rgba(0, 102, 255, 0.1);
}
@media (max-width: 959px) {
  .lang-pill {
    background: rgba(255, 255, 255, 0.16);
    border-color: rgba(255, 255, 255, 0.3);
    color: #fff;
    backdrop-filter: blur(8px);
  }
  .lang-pill .v-icon { color: #fff; }
}
</style>
